import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src3256605479/src/Portfolio/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3256605479/src/Portfolio/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3256605479/src/Portfolio/src/components/navBar/navBar.tsx");
